<template>
  <div>
    <Table :columns="columns" :data="tableData">
      <template slot-scope="{ row }" slot="action">
        <span class="table-btn" @click="openDetail(row)">明细</span>
      </template></Table
    >
    <Page v-if="showPage" :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <!-- 保单详情  -->
    <riseModal ref="riseModalRef" @openDetail="openPolicyDetail"></riseModal>
    <riseModal ref="riseModalRef1" @openDetail="openPolicyDetail"></riseModal>
  </div>
</template>

<script>
import riseModal from './riseModal';
import { common, pageTool } from '@/api/mixins';
import config from './templateList.config';
export default {
  mixins: [common, pageTool],
  components: {
    riseModal
  },
  props: {
    showPage: { type: Boolean, default: true }
  },
  data() {
    return config;
  },
  created() {
    const { reportId, tabVal, orgId, userId, detailId } = this.$route.query;
    this.reportId = reportId;
    this.tabVal = tabVal;
    this.orgId = orgId;
    this.userId = userId;
    this.detailId = detailId;
    this.getList();
  },
  methods: {
    openPolicyDetail(row) {
      console.log('row', row);
      // return;
      let params = {
        detailId: row.detailId,
        salaryDetailId: row.salaryDetailId
      };
      if (row.detailCode == 'xlhAddMemberDetailQuery') {
        params.userId = row.userId;
      } else if (row.detailCode == 'xlhRecommandDetailQuery') {
        params.orgId = row.organizationId;
      } else if (row.detailCode == 'xlhCultivateAwardDetailQuery' || row.detailCode == 'okBaoManageDetailQuery' || row.detailCode == 'okBaoRecommandDetailQuery' || row.detailCode == 'okBaoCultivateDetailQuery') {
        params.userId = row.userId;
      } else if (row.detailCode == 'xlhManageDetailQuery') {
        params.rankId = row.rankId;
      }
      if(row.detailCode == 'xlhManageDetailQuery'){
        this.$refs.riseModalRef1.open({
          columns: this.columns_13,
          params,
          detailCode: row.detailCode
        });
      }else if(row.detailCode == 'okBaoRecommandDetailQuery'){
        this.$refs.riseModalRef1.open({
          columns: this.columns_14,
          params,
          detailCode: row.detailCode
        });
      }else if(row.detailCode == 'okBaoManageDetailQuery' || row.detailCode == 'okBaoCultivateDetailQuery'){
        this.$refs.riseModalRef1.open({
          columns: this.columns_15,
          params,
          detailCode: row.detailCode
        });
      }else{
        this.$refs.riseModalRef1.open({
          columns: this.columns_1,
          params,
          detailCode: row.detailCode
        });
      }

    },
    openDetail(item) {
      // return;
      let columns = null;
      if (item.detailCode == 'fycDetailQuery') {
        columns = _.cloneDeep(this.columns_1);
      } else if (item.detailCode == 'rycDetailQuery') {
        columns = _.cloneDeep(this.columns_2);
      } else if (item.detailCode == 'xlhRankAwardDetailQuery') {
        columns = _.cloneDeep(this.columns_3);
      } else if (item.detailCode == 'xlhAddMemberDetailQuery') {
        columns = _.cloneDeep(this.columns_4);
      } else if (item.detailCode == 'xlhRecommandDetailQuery') {
        columns = _.cloneDeep(this.columns_5);
      } else if (item.detailCode == 'xlhCultivateAwardDetailQuery') {
        columns = _.cloneDeep(this.columns_6);
      } else if (item.detailCode == 'xlhManageDetailQuery') {
        columns = _.cloneDeep(this.columns_7);
      } else if (item.detailCode == 'okBaoFycDetailQuery') {
        columns = _.cloneDeep(this.columns_12);
      } else if (item.detailCode == 'okBaoRycDetailQuery') {
        columns = _.cloneDeep(this.columns_8);
      } else if (item.detailCode == 'okBaoManageDetailQuery') {
        columns = _.cloneDeep(this.columns_9);
      } else if (item.detailCode == 'okBaoRecommandDetailQuery') {
        columns = _.cloneDeep(this.columns_10);
      } else if (item.detailCode == 'okBaoCultivateDetailQuery') {
        columns = _.cloneDeep(this.columns_11);
      }

      let title = null
      if(item.detailCode == 'okBaoManageDetailQuery' || item.detailCode == 'okBaoRecommandDetailQuery' || item.detailCode == 'okBaoCultivateDetailQuery'){
        title = item.commissionName
      }else if(item.detailCode == 'xlhAddMemberDetailQuery' || item.detailCode == 'xlhCultivateAwardDetailQuery' || item.detailCode == 'xlhRecommandDetailQuery' || item.detailCode == 'xlhManageDetailQuery'){
        title = '明细'
      }else{
        title = '保单明细'
      }

      this.$refs.riseModalRef.open({
        columns,
        params: { detailId: item.id, salaryDetailId: item.id,title:title },
        detailCode: item.detailCode
      });
    },
    getList() {
      this.listLoading = true;
      let data = {
        id: this.detailId
      };
      this.$http({
        url: '/buz/userSettlementDetail/baseMethod/detail',
        type: 'GET',
        data
      })
        .then(res => {
          this.tableData = res.data;
          this.$emit('showTable', res.data == 0 ? false : true, 8);
        })
        .catch(e => {
          this.listLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
